module.exports = __webpack_public_path__ + "img/antes_despues_75.5b237bc3.png";